
// // 通用验证,（memeberweb使用）
// window.ltCaptchaModal.init({
//   env: process.env.NODE_ENV === 'production' ? 'prod' : 'test', // 环境变量
//   game: 'id', // 游戏标识 | 系统标识
//   api: {
//     // getmodeBySys: process.env.VUE_APP_CAPTCHA // 获取验证码模式请求地址
//   }
// })
export const ltCaptcha = (callbackHandler) => {
  // console.log('ltCaptcha')
  window.ltCaptchaModal.open((res) => {
    // console.log('open2', res)
    callbackHandler && callbackHandler(res)
  })
}
